import snsAxiosClient from '../common/http/http-sns';

function cancelSubscription(environmentVariables, user, cancelSubscriptionInfo) {
  const payload = { ...cancelSubscriptionInfo };
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_PATCH_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };
  return snsAxiosClient(options).patch(
    `${environmentVariables.SNS_CANCEL_SUBSCRIPTION}${user.UUID}/cancelSubscription`,
    payload,
  );
}

export default cancelSubscription;
